import MarketingPageLayout from "../components/MarketingPageLayout";
import SeoHelmet from "../components/SeoHelmet";
import MarketingHero from "../components/MarketingHero";
import FeatureCardGrid from "../components/FeatureCardGrid";
import { Timer, Play, NotebookPen, Smile, Tag, Youtube, Film } from "lucide-react";
import InternalLinks from "../components/InternalLinks";
import CtaFinal from "../components/CtaFinal";
import { MARKETING_META } from "../seoMeta";
import { FEATURE_SOFTWARE_LD } from "../data/featurePages";
import useTranslation from "../../client/hooks/useTranslation";

const PATH = "/fonctionnalites/sessions-de-trading";

export default function FeatureSessionsPage() {
  const t = useTranslation();
  const m = MARKETING_META[PATH];
  const c = t.marketing.features.sessions;
  return (
    <MarketingPageLayout>
      <SeoHelmet path={PATH} title={m.title} description={m.description} jsonLd={[FEATURE_SOFTWARE_LD]} />
      <MarketingHero h1={c.h1} subtitle={c.subtitle} />
      <FeatureCardGrid
        bullets={c.bullets}
        image="/images/features/sessions.png"
        imageAlt={c.h1}
        icons={[Timer, Play, NotebookPen, Smile, Tag, Youtube, Film]}
      />
      <InternalLinks
        links={[
          { to: "/tarifs", label: t.marketing.nav.pricing },
          { to: "/journal-de-trading", label: t.marketing.nav.megaFeatures[0].label },
          { to: "/fonctionnalites/analytics-trading", label: t.marketing.nav.megaFeatures[2].label },
        ]}
      />
      <CtaFinal />
    </MarketingPageLayout>
  );
}
